import VConsole from 'vconsole'

if (process.env.VUE_APP_VCONSOLE === 'true') {
  // eslint-disable-next-line
  new VConsole({ theme: 'dark' })
}
